import { Component } from '@theme/component';

class KaefPersonalization extends Component {
  validateFile(event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    const file = input.files?.[0];
    const valid = !file || (file.size <= 10 * 1024 * 1024 && ['image/jpeg', 'image/png', 'application/pdf'].includes(file.type));
    input.setCustomValidity(valid ? '' : this.dataset.fileError);
    if (!valid) input.reportValidity();
  }
}

if (!customElements.get('kaef-personalization')) {
  customElements.define('kaef-personalization', KaefPersonalization);
}
